import { render, staticRenderFns } from "./PrimaryPets.vue?vue&type=template&id=3a692eee"
import script from "./PrimaryPets.vue?vue&type=script&lang=js"
export * from "./PrimaryPets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports